import {Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy} from '@angular/core';
import {CardLightDto, CardService} from '../../../_services/configuration-services';

@Component({
    selector: 'app-customer-cards-summary',
    templateUrl: './customer-cards-summary.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CustomerCardsSummaryComponent implements OnChanges {

    @Input() serviceId: string = null!;
    @Input() customerId: string = null!;

    customerCards: CardLightDto[] = [];

    constructor(private readonly cardService: CardService) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['customerId']?.currentValue) {
            // The for-service variant is open to exploitants ([AuthorizeExploitant]); the plain
            // getCardsForCustomer requires the GestionClients permission and would 403 for them.
            this.cardService.getCardsForCustomerForService(this.serviceId, this.customerId)
                .subscribe(customerCards => this.customerCards = customerCards);
        }
    }
}
